import { login, loginByMsid, logout, getInfo } from '@desktop/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { validateUserType } from '@/utils/validate'
import router from '@desktop/router'
import {
  setStore,
  getStore,
  removeStore
} from '@/utils/store'
const user = {
  state: {
    loginForm: {
      userType:'user',
      username: '',
      password: '',
      code:'FFFF'
    },
    userData: getToken('userData') ? JSON.parse(getToken('userData')) : null,
    msid: getToken('msid') || '',
    userType:'',

    token: getToken('myToken') || undefined,
    name: getToken('name') || '',
    currentMenus:[],
    avatar: getToken('avatar') || '',
    roles: eval(getToken('roles')) || [],
    browserHeaderTitle: getStore({
      name: 'browserHeaderTitle'
    }) || '营上电器SRM'
  },
  mutations: {
    SET_USERDATA: (state, data) => {
      setToken('userData', JSON.stringify(data));
      let userType = validateUserType(data.type);
      setToken('userType',userType);
      state.userType = userType;
      state.userData = data;
    },
    SET_MSID: (state, data) => {
      state.msid = data;
    },
    SET_TOKEN: (state, token) => {
      state.token = token
      setToken('myToken', token);
      setToken('userType', state.loginForm.userType);
    },
    SET_NAME: (state, name) => {
      state.name = name
      setToken('name', name)
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
      setToken('avatar', avatar)
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
      setToken('roles', roles)
    },
    SET_BROWSERHEADERTITLE: (state, action) => {
      state.browserHeaderTitle = action.browserHeaderTitle
    }
  },
  actions: {
    Login({ commit,state }) {
      let loginForm = state.loginForm;
      let username = loginForm.username.trim();
      return new Promise((resolve, reject) => {
        login(username, loginForm.password).then(res => {
          console.log(res)
          /*commit('SET_TOKEN', res.token)
          commit('SET_ROLES', res.roles)
          commit('SET_NAME', res.name)
          commit('SET_AVATAR', res.avatar)
          if(state.loginForm.userType=='user'){
            router.push({ path: '/user' })
          }else{
            router.push({ path: '/supplier' })
          }*/
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    LoginByMsid({ commit, state },data) {
      return new Promise((resolve, reject) => {
        loginByMsid({msid:data}).then(res => {
          commit('SET_MSID',data)
          commit('SET_USERDATA',res.data)
          if(state.userType=='haier'){
            router.push({ path: '/user' })
          }else if(state.userType=='supplier'){
            router.push({ path: '/supplier' })
          }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo(state.token).then(response => {
          const data = response
          if (data.roles && data.roles.length > 0) {
            commit('SET_ROLES', data.roles)
          } else {
            reject('getInfo: roles must be a non-null array !')
          }
          commit('SET_NAME', data.name)
          commit('SET_AVATAR', data.avatar)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    LoginOut({ commit, state }) {
      removeToken('userData')
      removeToken('msid')
      removeToken('userType')
      router.push({ path: '/login' })
    },
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    },
    ChangeRoles({ commit }, role) {
      return new Promise(resolve => {
        commit('SET_TOKEN', role)
        setToken(role)
        getInfo(role).then(response => {
          const data = response
          commit('SET_ROLES', data.roles)
          commit('SET_NAME', data.name)
          commit('SET_AVATAR', data.avatar)
          resolve()
        })
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/modules/desktop/store/modules/user.js